export function createNotificationsQuery(repository) {
    return {
        invalidateOn: ["domain.entity-changed", "sync.delta-applied"],
        key: (row) => row.id,
        name: "notifications.list.v1",
        run: async (params) => await repository.listNotifications(parseNotificationListParams(params)),
    };
}
export function parseNotificationListParams(value) {
    if (value === null || typeof value !== "object" || Array.isArray(value))
        throw invalid();
    const record = value;
    if (Object.keys(record).some((key) => !["limit", "unreadOnly"].includes(key)))
        throw invalid();
    if (record.limit !== undefined && (typeof record.limit !== "number" || !Number.isInteger(record.limit) || record.limit < 1 || record.limit > 100))
        throw invalid();
    if (record.unreadOnly !== undefined && typeof record.unreadOnly !== "boolean")
        throw invalid();
    return {
        ...(record.limit === undefined ? {} : { limit: record.limit }),
        ...(record.unreadOnly === undefined ? {} : { unreadOnly: record.unreadOnly }),
    };
}
function invalid() {
    return new TypeError("Invalid notifications query parameters");
}
//# sourceMappingURL=notifications.js.map